<template>
  <div class="pb-20 max-w-lg mx-auto mt-20 mx-2">
    <Intro :page="page" />
    <slot />
  </div>
</template>

<script>
import Intro from '@/components/step-page/Intro'

export default {
  components: { Intro },

  props: {
    page: { type: Object, required: true },
  },
}
</script>
